// extracted by mini-css-extract-plugin
module.exports = {"container":"legal_mentions_header-module--container--267U_"};